import { render } from "./AddOrEditWithoutPersons.vue?vue&type=template&id=6f22b27f&scoped=true"
import script from "./AddOrEditWithoutPersons.vue?vue&type=script&lang=js"
export * from "./AddOrEditWithoutPersons.vue?vue&type=script&lang=js"

import "./AddOrEditWithoutPersons.vue?vue&type=style&index=0&id=6f22b27f&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f22b27f"]])

export default __exports__